import { StorageProviderType } from 'types/storageProvider';

export const PROVIDER_TYPES: StorageProviderType[] = [
  's3',
  'r2',
  'minio',
  'gdrive',
];

/** Sample credentials JSON per provider so the user can edit values instead of typing the structure. */
export const SAMPLE_CREDENTIALS: Record<StorageProviderType, string> = {
  s3: `{
  "accessKeyId": "YOUR_ACCESS_KEY_ID",
  "secretAccessKey": "YOUR_SECRET_ACCESS_KEY",
  "region": "us-east-1",
  "bucket": "your-bucket-name"
}`,
  r2: `{
  "accessKeyId": "YOUR_R2_ACCESS_KEY_ID",
  "secretAccessKey": "YOUR_R2_SECRET_ACCESS_KEY",
  "accountId": "YOUR_CLOUDFLARE_ACCOUNT_ID",
  "bucket": "your-r2-bucket-name"
}`,
  minio: `{
  "accessKeyId": "YOUR_MINIO_ACCESS_KEY",
  "secretAccessKey": "YOUR_MINIO_SECRET_KEY",
  "endpoint": "http://localhost:9000",
  "bucket": "your-bucket-name"
}`,
  gdrive: `{
  "clientId": "YOUR_GOOGLE_CLIENT_ID",
  "clientSecret": "YOUR_GOOGLE_CLIENT_SECRET",
  "refreshToken": "YOUR_REFRESH_TOKEN"
}`,
};
